export enum EventType {
  CLICKEVENT = 'click-event',
  NOTIFICATIONEVENT = 'notification-event',
  GRIDEVENT = 'grid-event'
}
